import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { cn } from "@util/helpers";

type WinnersTabProps = {
  /** Years array used to display the years tabs */
  years: string[];
  /** Function to set the selected tab*/
  setSelectedYear: (year: string) => void;
  /** Function to toggle the display of tabs*/
  setShowTabs: (state: boolean) => void;
  /** Selected year to show the respective winners */
  selectedYear: string;
};
/**
 * Component to render tabs for winners page
 */
const WinnersTab = ({
  years,
  setSelectedYear,
  setShowTabs,
  selectedYear,
}: WinnersTabProps): React.ReactElement => {
  return (
    <div
      className={cn(
        "absolute mb-2 flex h-[900px] flex-col flex-wrap border border-gray-200 bg-white p-4 shadow-sm md:h-[350px] md:w-10/12 lg:w-5/12",
        { "h-auto w-3/4 flex-row md:h-auto md:w-6/12": years.length < 5 }
      )}
    >
      {years.map((year) => (
        <ButtonFactory
          key={year}
          buttonType={ButtonType.Primary}
          text={year}
          onClick={() => {
            setSelectedYear(year);
            setShowTabs(false);
          }}
          className={cn(
            "rounded-none bg-white px-4 py-2 text-left text-base text-gray-875 transition-colors hover:bg-gray-100",
            {
              "bg-gray-650 text-white hover:bg-gray-650": selectedYear === year,
            }
          )}
        />
      ))}
    </div>
  );
};

export default WinnersTab;
